module.exports = __webpack_public_path__ + "static/media/Viking295_4c.3e89a480.svg";